import { render, staticRenderFns } from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=template&id=61055072&scoped=true"
import script from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=style&index=0&id=61055072&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61055072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61055072')) {
      api.createRecord('61055072', component.options)
    } else {
      api.reload('61055072', component.options)
    }
    module.hot.accept("./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=template&id=61055072&scoped=true", function () {
      api.rerender('61055072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetPdpImageSetPickerLegacy.vue"
export default component.exports